<div [appEditableWithRole]="['MERCHANT_ADMIN']">
  <button
    mat-raised-button
    class="my-4"
    color="primary"
    [routerLink]="'create'"
    [routerLinkActive]="'active'"
  >
    <mat-icon>add</mat-icon>
    {{ "MERCHANT.BTN.ADD" | translate }}
  </button>

  <div *ngIf="(hasError$ | async) === true" class="spinner-container">
    <span color="warn">{{ "MERCHANT.ERROR.GET" | translate }}</span>
  </div>
  <br />

  <ng-container *ngIf="(isLoading$ | async) !== true">
    <div class="card-container" *ngFor="let marketingData of data$ | async">
      <app-merchant-marketing-data-card
        [data]="marketingData"
        [siteNames]="
          getSiteNamesByIds(sites$ | async, marketingData.merchantSiteIds)
        "
      ></app-merchant-marketing-data-card>
    </div>
  </ng-container>
</div>
